module.exports = __webpack_public_path__ + "img/share.fe071fa3.png";